import 'whatwg-fetch';
import _ from 'lodash';
import settings from './settings';

function getLifeRayAuthToken() {
    if (window.Liferay) {
        return window.Liferay.authToken;
    }
    return settings.p_auth;
}

function getQueryString(params) {
    const esc = encodeURIComponent;
    return _.keys(params)
        .map(k => `${esc(k)}=${esc(params[k])}`)
        .join('&');
}

const getUrl = (url, queryParams) => {
    if (_.keys(queryParams).length > 0) {
        url += `?${getQueryString(queryParams)}`;
    }
    return url;
};

export const getLifeRayUrl = () => {
    if (!window.Liferay) {
        return settings.lifeRayUrl;
    }
    return `${settings.lifeRayUrl}?p_auth=${getLifeRayAuthToken()}`;
};

const ApiUtils = {
    get(url, params = {}, options = {}) {
        options.method = 'get';
        return this.fetch(url, params, options);
    },
    post(url, body, params = {}, options = {}) {
        options.method = 'post';
        options.body = body;
        return this.fetch(url, params, options);
    },
    postToLifeRay(body, options = {}) {
        options.method = 'post';

        if (!window.Liferay) {
            options.headers = {
                'Content-type': 'application/json',
                Authorization: `Basic ${btoa(`${settings.liferay_username}:${settings.liferay_password}`)}`,
            };
        } else {
            options.headers = {
                'Content-type': 'application/json',
            };
            options.credentials = 'same-origin';
        }

        options.body = JSON.stringify(body);

        return this.fetchFromLifeRay(options);
    },
    fetch(url, params = {}, options = {}) {
        const timeout = new Promise((resolve, reject) => {
            setTimeout(
                () =>
                    reject(
                        new Error({
                            message: "Connection to the Internet couldn't be established",
                        })
                    ),
                settings.loadTimeout
            );
        });

        let {baseUrl} = settings;
        if (options.baseUrl) {
            // eslint-disable-next-line prefer-destructuring
            baseUrl = options.baseUrl;
        }

        const getData = new Promise((resolve, reject) => {
            fetch(baseUrl + getUrl(url, params), options)
                .then(response => ApiUtils.checkStatus(response))
                .then(response => {
                    if (options.type === 'text') {
                        return response.text();
                    }
                    return response.json();
                })
                .then(json => {
                    resolve(json);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return Promise.race([timeout, getData]);
    },
    fetchFromLifeRay(options = {}) {
        const lifeRayTimeout = new Promise((resolve, reject) => {
            setTimeout(
                () =>
                    reject(
                        new Error({
                            message: "Connection to the Internet couldn't be established",
                        })
                    ),
                settings.loadTimeout
            );
        });

        const liferayGetData = new Promise((resolve, reject) => {
            fetch(getLifeRayUrl(), options)
                .then(response => ApiUtils.checkLiferayStatus(response))
                .then(response => {
                    if (options.type === 'text') {
                        return response.text();
                    }
                    return response.json();
                })
                .then(json => {
                    if (json.error) {
                        throw json;
                    }
                    resolve(json);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return Promise.race([lifeRayTimeout, liferayGetData]);
    },
    checkStatus(response) {
        if (response.type === 'opaque') return response;
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        throw response.error;
    },
    checkLiferayStatus(response) {
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        if (response.status === 500) {
            return response;
        }
        throw response;
    },
    convertToSelectOptions(list) {
        return _.map(list, obj => ({value: obj.id, label: obj.name}));
    },
    convertToSelectOption(option) {
        if (option == null || !option.id) return '';
        return {value: option.id, label: option.name};
    },

};

export default ApiUtils;
